import getRehydratableName from "@emcm-ui/utility-rehydratable-name";

export default {
  [getRehydratableName("DismissibleBanner")]: async (...args) =>
    (await import("@emcm-ui/component-dismissible-banner")).rehydrator(...args),
  [getRehydratableName("Dropdown")]: async (...args) =>
    (await import("@emcm-ui/component-dropdown")).rehydrator(...args),
  [getRehydratableName("Expandable.Item")]: async (...args) =>
    (await import("@emcm-ui/component-expandable")).rehydrator(...args),
  [getRehydratableName("GlobalFooter")]: async (...args) =>
    (await import("@emcm-ui/component-global-footer")).rehydrator(...args),
  [getRehydratableName("GlobalHeader")]: async (...args) =>
    (await import("@emcm-ui/component-global-header")).rehydrator(...args),
  [getRehydratableName("GlobalHeader.BaseItem")]: async (...args) =>
    (await import("@emcm-ui/component-global-header")).baseItemRehydrator(
      ...args
    ),
  [getRehydratableName("GlobalHeader.Cart")]: async (...args) =>
    (await import("@emcm-ui/component-global-header")).cartRehydrator(...args),
  [getRehydratableName("GlobalHeader.Login")]: async (...args) =>
    (await import("@emcm-ui/component-global-header")).loginRehydrator(...args),
  [getRehydratableName("Figure")]: async (...args) =>
    (await import("@emcm-ui/component-figure")).rehydrator(...args),
  [getRehydratableName("Form")]: async (...args) =>
    (await import("@emcm-ui/component-form")).formRehydrator(...args),
  [getRehydratableName("Form.CampaignControl")]: async (...args) =>
    (await import("@emcm-ui/component-form")).campaignControlRehydrator(
      ...args
    ),
  [getRehydratableName("Form.PrivacyControl")]: async (...args) =>
    (await import("@emcm-ui/component-form")).privacyControlRehydrator(...args),
  [getRehydratableName("HorizontalOverflow")]: async (...args) =>
    (await import("@emcm-ui/component-horizontal-overflow")).rehydrator(
      ...args
    ),
  [getRehydratableName("Longform.ChapterNavInner")]: async (...args) =>
    (await import("@emcm-ui/component-longform")).chapterNavRehydrator(...args),
  [getRehydratableName("Longform.ChapterNav.Chapter")]: async (...args) =>
    (await import("@emcm-ui/component-longform")).chapterNavChapterRehydrator(
      ...args
    ),
  [getRehydratableName("PageNavInner")]: async (...args) =>
    (await import("@emcm-ui/component-page-nav")).rehydrator(...args),
  [getRehydratableName("PageNav.Item")]: async (...args) =>
    (await import("@emcm-ui/component-page-nav")).itemRehydrator(...args),
  [getRehydratableName("SearchFilters.Filters")]: async (...args) =>
    (await import("@emcm-ui/component-search-filters")).filtersRehydrator(
      ...args
    ),
  [getRehydratableName("SearchFilters.FilterSectionOverflow")]: async (
    ...args
  ) =>
    (await import("@emcm-ui/component-search-filters")).filterSectionOverflowRehydrator(
      ...args
    ),
  [getRehydratableName("SearchFilters.Selected")]: async (...args) =>
    (await import("@emcm-ui/component-search-filters")).selectedReyhdrator(
      ...args
    ),
  [getRehydratableName("SearchInput")]: async (...args) =>
    (await import("@emcm-ui/component-search-input")).rehydrator(...args),
  [getRehydratableName("ShowMore")]: async (...args) =>
    (await import("@emcm-ui/component-show-more")).rehydrator(...args),
  [getRehydratableName("SiteFooter")]: async (...args) =>
    (await import("@emcm-ui/component-site-footer")).rehydrator(...args),
  [getRehydratableName("SiteFooter.NavList")]: async (...args) =>
    (await import("@emcm-ui/component-site-footer")).navListRehydrator(...args),
  [getRehydratableName("SiteHeader")]: async (...args) =>
    (await import("@emcm-ui/component-site-header")).rehydrator(...args),
  [getRehydratableName("SiteHeader.Menu")]: async (...args) =>
    (await import("@emcm-ui/component-site-header")).menuRehydrator(...args),
  [getRehydratableName("SiteHeaderFlyouts")]: async (...args) =>
    (await import("@emcm-ui/component-site-header")).flyoutsRehydrator(...args),
  [getRehydratableName("SiteHeader.Flyouts.TabPanel")]: async (...args) =>
    (await import("@emcm-ui/component-site-header")).flyoutsPanelRehydrator(
      ...args
    ),
  [getRehydratableName("SocialDropdown")]: async (...args) =>
    (await import("@emcm-ui/component-social-dropdown")).rehydrator(...args),
  [getRehydratableName("TableWithFilters")]: async (...args) =>
    (await import("@emcm-ui/component-table-with-filters")).rehydrator(...args),
  [getRehydratableName("Tabs")]: async (...args) =>
    (await import("@emcm-ui/component-tabs")).rehydrator(...args),
  [getRehydratableName("Tabs.Panel")]: async (...args) =>
    (await import("@emcm-ui/component-tabs")).panelRehydrator(...args),
  [getRehydratableName("TabsAdvanced")]: async (...args) =>
    (await import("@emcm-ui/component-tabs-advanced")).rehydrator(...args),
  [getRehydratableName("Ticker")]: async (...args) =>
    (await import("@emcm-ui/component-ticker")).rehydrator(...args),
  [getRehydratableName("Ticker.Item")]: async (...args) =>
    (await import("@emcm-ui/component-ticker")).itemRehydrator(...args),
  [getRehydratableName("TwitterCardTimeline")]: async (...args) =>
    (await import("@emcm-ui/component-card")).twitterCardTimelineRehydrator(
      ...args
    ),
  [getRehydratableName("VideoPlayerCore")]: async (...args) =>
    (await import("@emcm-ui/component-video-player")).rehydrator(...args),
  [getRehydratableName("UserInfo")]: async (...args) =>
    (await import("./components/UserInfo")).rehydrator(...args),
  [getRehydratableName("CartInfo")]: async (...args) =>
    (await import("./components/CartInfo")).rehydrator(...args)
};
